(function($){ 
   
  $('.switch-content > :not(section.checked)').hide();
  $('.switch-pre > :not(pre.checked)').hide();
  $('.switch-span > :not(span.checked)').hide();
  
  $('input[type="radio"]').on('change', function() {
    
    var selected_variant = $(this).attr('data-variant');
    $('select[name="id"]').val(selected_variant).change();
    
    var selected_section = $('.switch-content > section[toggle-id="'+ selected_variant +'"]').attr('toggle-id');
    var selected_pre = $('.switch-pre > pre[toggle-id="'+ selected_variant +'"]').attr('toggle-id');
    var selected_span = $('.switch-span > span[toggle-id="'+ selected_variant +'"]').attr('toggle-id');
    
    if (selected_variant == selected_section ) {
      $('.switch-content > section[toggle-id="'+ selected_variant +'"]').show();     
      $('.switch-content > :not(section[toggle-id="'+ selected_variant +'"])').hide();      
    } else {
      $('.switch-content > :not(section[toggle-id="'+ selected_variant +'"])').show();     
      $('.switch-content > section[toggle-id="'+ selected_variant +'"]').hide();      
    }

     if (selected_variant == selected_pre) {     
      $('.switch-pre > pre[toggle-id="'+ selected_variant +'"]').show();      
      $('.switch-pre > :not(pre[toggle-id="'+ selected_variant +'"])').hide();     
    } else {     
      $('.switch-pre > :not(pre[toggle-id="'+ selected_variant +'"])').show();      
      $('.switch-pre > pre[toggle-id="'+ selected_variant +'"]').hide();      
    }

     if (selected_variant == selected_span) {     
      $('.switch-span > span[toggle-id="'+ selected_variant +'"]').show();      
      $('.switch-span > :not(span[toggle-id="'+ selected_variant +'"])').hide();     
    } else {     
      $('.switch-span > :not(span[toggle-id="'+ selected_variant +'"])').show();      
      $('.switch-span > span[toggle-id="'+ selected_variant +'"]').hide();      
    }
  });
  
})(jQuery);